export default __webpack_public_path__ + "static/media/Rubik-LightItalic.e07b32f4.ttf";